'use strict';

import { documentReady } from "./Shared/DocumentReady";
import '../css/pages/donor-registration.scss';
import AnonymousDonor from "./AnonymousDonor/AnonymousDonor";
import PaymentOptions, { DONOR } from "./PaymentOptions/PaymentOptions";
import FormWithPaymentSubmit from "./FormWithPaymentSubmit/FormWithPaymentSubmit";

documentReady(() => {
    window.super();
    const script = document.querySelector('script[src^="/assets/donor-registration.bundle.js"]');
    const loggedInAsProvider = script.getAttribute('data-logged-in-as-provider');
    // @todo: Due to last moment changes, too much going on in the payment options.
    // can be simplified again.
    new FormWithPaymentSubmit(
        new PaymentOptions(
            DONOR,
            '0.00',
            loggedInAsProvider !== '1',
            new AnonymousDonor()
        ),
        'donor-registration'
    );
});
